import { z } from 'zod';
/**
 * Bulk-Actions auf Projekt-Listen. Backend prüft Permissions + Read-Only-Status
 * pro ID einzeln und liefert eine Result-Liste, was erfolgreich war und was nicht.
 */
export const BulkAction = z.enum(['archive', 'set_priority', 'set_status', 'delete']);
export const bulkProjectRequest = z.object({
    ids: z.array(z.number().int().positive()).min(1).max(200),
    action: BulkAction,
    /** Wenn action === 'set_priority' */
    priority: z.enum(['low', 'medium', 'high']).optional(),
    /** Wenn action === 'set_status' (nur draft/planning/in_review erlaubt — keine status-transitions) */
    status: z.enum(['draft', 'planning', 'in_review']).optional(),
});
export const bulkResultItem = z.object({
    id: z.number().int().positive(),
    ok: z.boolean(),
    reason: z.string().optional(),
});
export const bulkResponse = z.object({
    total: z.number().int().nonnegative(),
    succeeded: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    items: z.array(bulkResultItem),
});
